var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSearchList(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 75,
    viewBox: "0 0 68 75",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M64.5801 71.4675L57.1855 64.0729M57.1855 64.0729C59.399 61.8583 60.6428 58.8554 60.6434 55.7243C60.6437 52.9918 59.6965 50.3439 57.9632 48.2316C56.2299 46.1192 53.8178 44.6733 51.1379 44.1401C48.458 43.6069 45.6761 44.0195 43.2664 45.3076C40.8566 46.5956 38.9679 48.6794 37.9223 51.2038C36.8767 53.7283 36.7388 56.5372 37.5321 59.1519C38.3254 61.7666 40.0009 64.0254 42.2729 65.5433C44.545 67.0611 47.273 67.7442 49.9923 67.4761C52.7115 67.208 55.2537 66.0053 57.1855 64.0729Z",
    stroke: "currentColor",
    strokeWidth: 5.16623,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.1372 71.4661H29.197C17.969 71.4661 12.3482 71.4661 8.44938 68.7176C7.33984 67.9395 6.34809 67.0058 5.50463 65.9451C2.58398 62.2736 2.58398 56.9903 2.58398 46.4167V37.6514C2.58398 27.4463 2.58398 22.3421 4.19929 18.2677C6.79618 11.7135 12.2862 6.54723 19.2502 4.10188C23.5761 2.58301 28.9937 2.58301 39.8428 2.58301C46.0354 2.58301 49.1351 2.58301 51.608 3.45093C55.586 4.84926 58.7237 7.8009 60.2081 11.5447C61.1346 13.8729 61.1346 16.7901 61.1346 22.6211V37.0245",
    stroke: "currentColor",
    strokeWidth: 5.16623,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.58398 37.0245C2.58398 33.98 3.79341 31.0602 5.94621 28.9074C8.09901 26.7546 11.0188 25.5452 14.0633 25.5452C16.3572 25.5452 19.0608 25.9447 21.2892 25.3489C22.2629 25.0868 23.1506 24.5734 23.8633 23.8601C24.576 23.1468 25.0886 22.2587 25.3498 21.2848C25.9457 19.0564 25.5462 16.3527 25.5462 14.0589C25.5471 11.015 26.7569 8.09607 28.9096 5.94402C31.0623 3.79196 33.9816 2.58301 37.0255 2.58301",
    stroke: "currentColor",
    strokeWidth: 5.16623,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchList);
export default __webpack_public_path__ + "static/media/search-list.e837460e3ef85568f8e3efa33ef82ada.svg";
export { ForwardRef as ReactComponent };